import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SharedNotificationService {
    // loaders
    private _isLoadingRowResults: boolean;
    private _onSupplierChange?: number;
    private _onPrintUnprintedLabels: boolean;
    private _onPrintPrintedLabels: boolean;

    private onTabChange = new Subject<boolean>();
    private onSupplierChange = new Subject<number>();
    private onPrintUnprintedLabels = new Subject<boolean>();
    private onPrintPrintedLabels = new Subject<boolean>();
    private isLoadingRowResults = new Subject<boolean>();

    public onTabChangeObservable = this.onTabChange.asObservable();
    public onSupplierChangeObservable = this.onSupplierChange.asObservable();
    public onPrintUnprintedLabelsObservable = this.onPrintUnprintedLabels.asObservable();
    public onPrintPrintedLabelsObservable = this.onPrintPrintedLabels.asObservable();
    public isLoadingRowResultsObservable = this.isLoadingRowResults.asObservable();

    constructor() {
        this._isLoadingRowResults = false;
        this._onPrintUnprintedLabels = false;
        this._onPrintPrintedLabels = false;
        this._onSupplierChange = null;
    }

    // getters
    get getIsLoadingRowResults(): boolean { return this._isLoadingRowResults; }
    get getOnSupplierChange(): number { return this._onSupplierChange; }
    get getOnPrintUnprintedLabels(): boolean { return this._onPrintUnprintedLabels; }
    get getOnPrintPrintedLabels(): boolean { return this._onPrintPrintedLabels; }

    // setters
    public setOnPrintUnprintedLabels(val: boolean) {
        this._onPrintUnprintedLabels = val;
        this.onPrintUnprintedLabels.next(val);
    }

    public setOnPrintPrintedLabels(val: boolean) {
        this._onPrintPrintedLabels = val;
        this.onPrintPrintedLabels.next(val);
    }

    public setIsLoadingRowResults(val: boolean) {
        this._isLoadingRowResults = val;
        this.isLoadingRowResults.next(val);
    }

    public setOnTabChange() {
        this.onTabChange.next(true);
    }

    public setOnSupplierChange(val: number) {
        this._onSupplierChange = val;
        this.onSupplierChange.next(val);
    }
}
